import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";

const AuthCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Check for error from Google OAuth
    const error = searchParams.get('error');
    
    if (error) {
      console.error('[AuthCallback] OAuth error:', error);
      
      // Map error codes to user-friendly messages
      const errorMessages = {
        'google_auth_failed': 'Google sign-in failed. Please try again.',
        'invalid_callback': 'Invalid authentication response.',
        'invalid_state': 'Authentication session expired. Please try again.',
        'token_exchange_failed': 'Failed to complete sign-in. Please try again.',
        'no_access_token': 'Authentication incomplete. Please try again.',
        'userinfo_failed': 'Could not retrieve your profile. Please try again.',
        'no_email': 'Email access is required. Please try again.',
        'auth_failed': 'Authentication failed. Please try again.'
      };
      
      toast.error(errorMessages[error] || 'Sign-in failed. Please try again.');
      navigate('/login', { replace: true });
      return;
    }
    
    // If we're here without an error, the OAuth was successful
    // The cookie is already set by the backend, just redirect to app
    console.log('[AuthCallback] OAuth successful, redirecting to app');
    navigate('/app', { replace: true });
    
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-muted-foreground">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
